<aside id="change-container" class="change-action big-input-grid">
  <h4 class="to"><span>to</span></h4>
  <app-autocomplete #fieldValue [selectedOptionControl]="valueControl"
                    [componentId]="'change-fieldValue'" [placeholder]="toManyPlaceholderText ? toManyPlaceholderText : 'Enter a value...'"></app-autocomplete>
</aside>
